/* eslint-disable */
import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, alignItems, justifyContent, flexDirection } from '../../styles/helpers/flexbox';

export const DefaultCoursesWrapper = styled.div(props => {
    const { palette, typography, colours } = ThemeHelper.getTheme(props);
    
    return `
    ${flexbox()}
    ${alignItems('center')}
    ${justifyContent('center')}
    background-color: ${colours.porcelain}
    padding: 15px
    color: ${palette.primary.dark}
    font-family: ${typography.family}
`});

export const DefaultCoursesContainer = styled.div`
    ${flexbox()}
    ${alignItems('flex-start')}
    ${justifyContent('flex-start')}
    ${flexDirection('column')}
    flex: 1;
    background-color: white;
    padding: 15px;
    width: 100%;
    border-radius: 3px;
`;

export const Header = styled.div(props => {
    const { colours } = ThemeHelper.getTheme(props);
    
    return `${flexbox()}
    ${alignItems('center')}
    ${justifyContent('flex-start')}
    min-height: 60px
    padding-left: 50px
    background-color: ${colours.iron}
    border: 1px solid ${colours.mercury}
    width: calc(100% - 50px)
`});

export const FilterDropdownWrapper = styled.div`
    ${flexbox()}
    ${alignItems('center')}
    ${justifyContent('flex-start')}
    width: 280px;

    .dropDownContainer {
        background-color: white;
    }
`;

export const YearDropDownWrapper = styled.div(props => {
    const { colours } = ThemeHelper.getTheme(props);
    
    return `
    ${flexbox()}
    width: 100%;
    border: 1px solid ${colours.mercury};
`});

export const DataColumn = styled.div(props => {
    const { colours } = ThemeHelper.getTheme(props);
    
    return `
    ${flexbox()}
    ${alignItems('center')}
    ${justifyContent('flex-start')}
    ${flexDirection('column')}
    height: 100%;
    width: ${props.width};
    border-right: 1px solid ${colours.mercury};
    padding: 28.5px 18.5px;

    .dropDownContainer {
        width: 100%;
    }
`});

export const DataRow = styled.div`
    ${flexbox()}
    ${alignItems('center')}
    ${justifyContent('center')}
    min-height: 40px;
    width: 100%;
    margin-bottom: ${props => props.isHeader ? '20px' : '10px'};
`;

export const FooterWrapper = styled.div(props => {
    const { colours } = ThemeHelper.getTheme(props);
    
    return `
    ${flexbox()}
    ${alignItems('center')}
    ${justifyContent('space-between')}    
    min-height: 50px;
    width: calc(100% - 20px);
    background-color: ${colours.hitGray};
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 3px 10px;

    .actionButton {
        height: 30px;
        width: 100px;
        background-color: ${colours.oxfordBlue};
        border-radius: 15px;
        color: white;
    }
`});

export const LoaderWrapper = styled.div`
    ${flexbox()}
    ${alignItems('center')}
    ${justifyContent('center')}

    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
`;

export const DropdownWrapper = styled.div`
    background-color: white;
    border-radius: 5px;
    margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./app/components/default-courses/styled.js